
import React, {FC, useState} from 'react';
import {useAccordionButton} from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import {Markdown} from 'components/Markdown';

import {Assistant} from './Assistant';
import {questions as defaultQuestions} from './faq';

import * as styles from './styles.module.scss';

type ButtonProps = {
    children: React.ReactNode;
    eventKey: string;
    onClick: () => void;
}

const Button: FC<ButtonProps> = ({children, eventKey, onClick}) => {
	const handleClick = useAccordionButton(eventKey, onClick);
	return (
		<button className={styles.button} onClick={handleClick}>
			{children}
		</button>
	);
};

type FAQProps = {
	questions?: {
		title: string;
		body: string;
	}[]
	defaultTab?: string;
}

const FAQ: FC<FAQProps> = ({
	questions = defaultQuestions,
	defaultTab = -1, // set to 0 for the first entry
}) => {
	const [currentTab, setCurrentTab] = useState(defaultTab);
	const handleClick = (i: number) => () => {
		if (currentTab === i) {
			setCurrentTab(-1);
		} else {
			setCurrentTab(i);
		}
	};

	return (
		<div className={styles.wrapper}>
			<h2>Frequently Asked Questions</h2>
			<Assistant />
			<Accordion defaultActiveKey={String(currentTab)}>
				{questions.map((q, i) => (
					<Card key={q.title} className={styles.card}>
						<Card.Header className={styles.header}>
							<Button eventKey={String(i)} onClick={handleClick(i)}>
								<span style={{textAlign: 'left'}}>
									{q.title}
								</span>
								<span className={styles.toggle}>
									{currentTab === i ? '-' : '+'}
								</span>
							</Button>
						</Card.Header>
						<Accordion.Collapse eventKey={String(i)}>
							<Card.Body>
								<Markdown markdown={q.body} />
							</Card.Body>
						</Accordion.Collapse>
					</Card>
				))}
			</Accordion>
		</div>
	);
};

export const Spacer = () => {
	return (
		<div className={styles.spacer} />
	);
};

export default Object.assign(FAQ, {
	Spacer,
});
